import { render, staticRenderFns } from "./gb_form0700.vue?vue&type=template&id=696c6062"
import script from "./gb_form0700.vue?vue&type=script&lang=js"
export * from "./gb_form0700.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports